import {getAbsolutePath} from './../imports.js';
import {get_dirname,make_path} from './path_utils.js';
/**
 * Returns the absolute path of the current file.
 */
export function getAbsDir(): string {
    return get_dirname(getAbsolutePath());
};
export function getAbsPath(subPath: string): string {
    return make_path(getAbsDir(), subPath);
}



